<template>
  <modal
    v-model="isActive"
    :append-to-body="true"
    :title="$t('NUMBER_SELECT_NUMBER_POOL')"
    :footer="false"
    @hide="$emit('cancel')"
  >
    <form
      role="form"
      class="form-horizontal"
      :name="formName"
      novalidate
    >
      <fieldset>
        <div class="container-fluid">
          <div class="form-group">
            <label
              v-t="'NUMBER_SELECT_NUMBER_POOL_NUMBER_LABEL'"
              class="col-sm-3 col-md-4 control-label"
            />
            <div class="col-sm-9 col-md-8 form-control-static text-bold">
              {{ selectedNumber.phoneNumber }}
            </div>
          </div>

          <div class="form-group">
            <label
              v-t="'NUMBER_SELECT_NUMBER_POOL'"
              class="col-sm-3 col-md-4 control-label"
            />
            <div class="col-sm-6 col-md-5">
              <SearchableDropdown
                v-model="selectedNumberPool"
                :config="poolsListConfig"
              />
            </div>
          </div>
          <div class="form-group text-align-right">
            <PrimaryButton
              :do-on-click="_onSubmit"
            >
              <span v-t="'NUMBER_SELECT_NUMBER_POOL_ADD_NUMBER_POOL'" />
            </PrimaryButton>
          </div>
        </div>
      </fieldset>
    </form>
  </modal>
</template>

<script>
import { defineComponent } from 'vue';
import sharedMessages from '@/core/locales';
import messages from '../../locales';
import SearchableDropdown from '@/core/components/SearchableDropdown/SearchableDropdown.vue';
import PrimaryButton from '@/core/components/PrimaryButton/index.vue';

export default defineComponent({
  components: {
    SearchableDropdown,
    PrimaryButton,
  },
  emits: ['cancel', 'submit'],
  props: {
    selectedNumber: {
      type: Object,
      required: true,
    },
    poolsList: {
      type: Array,
      required: true,
    },
    formName: { // selectNumberPoolForm
      type: String,
      required: false,
    },
    onSubmit: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      selectedNumberPool: null,
      isActive: true,
    };
  },
  computed: {
    poolsListConfig() {
      return {
        placeholder: this.$t('NUMBER_SELECT_NUMBER_POOL_SEARCH'),
        options: this.poolsList
          .filter(pool => validateNumberPoolOption(this.selectedNumber.countryCode, pool.assignmentSettings.countryCode))
          .map(pool => ({
            original: pool,
            label: pool.name,
            value: pool.id,
          })),
      };
    },
  },
  methods: {
    _onSubmit() {
      if (!this.selectedNumberPool?.original) {
        console.error('Number pool is not selected');
        return;
      }

      const args = {
        poolId: this.selectedNumberPool.original.id,
        numberId: this.selectedNumber.id,
      };
      const res = this.$props.onSubmit?.(args);
      this.$emit('submit', args);
      return res;
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  },
});

function validateNumberPoolOption(nCountry, npCountry) {
  if (nCountry === 'US' || nCountry === 'CA') {
    return npCountry === 'US' || npCountry === 'CA';
  }
  return nCountry === npCountry;
}

</script>
